import React from 'react';

const Message = ({ message, setMessage }) => {
  return (
    <div className={'bg-gray-100/70 rounded-2xl p-3'}>
      <p className={'text-xs pb-3'}>Отправить push-уведомление клиенту</p>
      <textarea
        id={'message'}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className={'w-full px-4 py-3 rounded-2xl min-h-[120px] outline-0 field-sizing-content resize-none'}
        placeholder={'Сообщение пользователю'}
      />
    </div>
  );
};

export default Message;
